export const translations = {
  pt: {
    seo: {
      title: "ETE, ETA e Tratamento de Água no RJ | Eco Build Engenharia",
      description: "Engenharia ambiental no RJ: implantação de ETE e ETA, tratamento de água e chorume, construções secas e energia solar fotovoltaica. Solicite um orçamento.",
      ogLocale: "pt_BR",
    },
    wordmark: "engenharia",
    nav: {
      home: "Home",
      sobre: "Sobre",
      servicos: "Serviços",
      projetos: "Projetos",
      case: "Case",
      contatos: "Contatos",
      cta: "Orçamento Rápido",
      menu: "Abrir menu",
      language: "Idioma",
    },
    hero: {
      badge: "Engenharia Civil · Ambiental · Elétrica",
      lines: ["Engenharia que", "trata a água,", "constrói o futuro."],
      sub: "Especialistas em tratamento de água e chorume, implantação de ETE/ETA, construções secas e energia solar fotovoltaica. Infraestrutura de precisão para um futuro sustentável.",
      cta1: "Falar com Especialistas",
      cta2: "Explorar Soluções",
      pillars: ["ETE & ETA", "Construções Secas", "Energia Fotovoltaica"],
      imageAlt: "Estação de tratamento de água",
    },
    marquee: [
      "Tratamento de Água · ETE / ETA",
      "Tratamento de Chorume",
      "Construções Secas · Steel Frame",
      "Energia Solar Fotovoltaica",
      "Gestão de Projetos",
      "Infraestrutura Elétrica",
    ],
    about: {
      eyebrow: "Sobre a Empresa",
      title: "Mais do que edifícios, construímos um legado.",
      p1: "A EcoBuild é líder em construções de alto padrão, integrando tecnologia sustentável em cada detalhe. Nosso compromisso é entregar projetos que aliam sofisticação, eficiência e respeito ao meio ambiente.",
      p2: "Com uma gestão de obras inovadora, garantimos excelência em cada etapa, desde o planejamento até a entrega final. Acreditamos que a construção sustentável não é apenas uma tendência, mas uma necessidade para o futuro.",
      quote: "“Na EcoBuild, construímos mais do que edifícios; construímos um legado de qualidade, inovação e responsabilidade ambiental.”",
      imageAlt: "Residência de alto padrão construída pela EcoBuild com tecnologia sustentável",
      cardEyebrow: "Nosso compromisso",
      cardText: "Sofisticação, eficiência e respeito ao meio ambiente.",
      values: [
        { id: "sustentabilidade", title: "Sustentabilidade", desc: "Tecnologia sustentável integrada em cada detalhe do projeto." },
        { id: "inovacao", title: "Inovação", desc: "Gestão de obras inovadora, do planejamento à entrega final." },
        { id: "excelencia", title: "Excelência", desc: "Alto padrão de qualidade e sofisticação em cada etapa executada." },
      ],
    },
    services: {
      eyebrow: "Nossos Serviços",
      title: "Soluções integradas de engenharia, do projeto à entrega.",
      lead: "Construímos, reformamos e gerenciamos projetos com o rigor técnico que a engenharia exige — e com a responsabilidade ambiental que o futuro cobra.",
      items: [
        {
          id: "construcoes",
          title: "Construções",
          alt: "Estrutura de construção em steel frame",
          desc: "Obras industriais, comerciais e residenciais executadas com precisão técnica, prazos controlados e materiais de alta performance.",
          bullets: ["Obras industriais e comerciais", "Estruturas de alta performance", "Controle rigoroso de qualidade"],
        },
        {
          id: "reformas",
          title: "Reformas",
          alt: "Equipe de engenharia em obra de reforma",
          desc: "Retrofit e reformas de alta complexidade, planejadas para modernizar sua estrutura com mínima interferência na operação.",
          bullets: ["Retrofit estrutural e arquitetônico", "Modernização de instalações", "Mínima interferência operacional"],
        },
        {
          id: "gestao",
          title: "Gestão de Projetos",
          alt: "Gestão de projeto de engenharia civil",
          desc: "Gerenciamento integral de projetos de engenharia: planejamento, cronograma, orçamento, fiscalização e compliance ambiental.",
          bullets: ["Planejamento e cronograma", "Fiscalização técnica de obras", "Compliance e licenciamento"],
        },
      ],
    },
    disciplines: {
      eyebrow: "Áreas de Atuação",
      title: "Três engenharias. Um único padrão de excelência.",
      items: [
        {
          id: "civil",
          code: "01",
          eyebrow: "Engenharia Civil",
          title: "Construções secas: velocidade, precisão e quase zero resíduo.",
          alt: "Estrutura metálica de construção seca",
          desc: "Lideramos a transição para sistemas construtivos industrializados. Com steel frame, drywall e fechamentos em placas, entregamos obras mais rápidas, limpas e eficientes que a alvenaria convencional.",
          bullets: [
            "Sistemas Steel Frame e Drywall",
            "Montagem rápida com alta eficiência térmica e acústica",
            "Obras sustentáveis com redução de até 70% de resíduos",
            "Precisão milimétrica de projeto industrializado",
          ],
          chips: ["Steel Frame", "Drywall", "Baixo Resíduo"],
        },
        {
          id: "ambiental",
          code: "02",
          eyebrow: "Engenharia Ambiental",
          title: "Tratamento de água e chorume com tecnologia de ponta.",
          alt: "Estação de tratamento de água",
          desc: "Projetamos e implantamos estações de tratamento de esgoto (ETE) e de água (ETA), além de sistemas completos para tratamento de chorume em aterros e indústrias — sempre em conformidade com a legislação ambiental.",
          bullets: [
            "Implantação de ETE — Estação de Tratamento de Esgoto",
            "Implantação de ETA — Estação de Tratamento de Água",
            "Tratamento de chorume em aterros e indústrias",
            "Gestão de projetos e licenciamento ambiental",
          ],
          chips: ["ETE", "ETA", "Chorume", "Licenciamento"],
        },
        {
          id: "eletrica",
          code: "03",
          eyebrow: "Engenharia Elétrica",
          title: "Energia renovável e infraestrutura para operar sem interrupções.",
          alt: "Painéis solares fotovoltaicos",
          desc: "Do projeto à homologação, implementamos sistemas de energia solar fotovoltaica e infraestruturas elétricas robustas que reduzem custos operacionais e a pegada de carbono do seu negócio.",
          bullets: [
            "Sistemas de energia solar fotovoltaica",
            "Infraestrutura elétrica de alta e média tensão",
            "Eficiência energética industrial",
            "Homologação junto à concessionária",
          ],
          chips: ["Fotovoltaica", "Alta Tensão", "Eficiência"],
        },
      ],
    },
    projects: {
      eyebrow: "Portfólio",
      title: "Projetos que transformam recursos em resultados.",
      lead: "Uma seleção ilustrativa da nossa atuação em estações de tratamento, energia renovável e construções de alta performance.",
      filters: [
        { id: "todos", label: "Todos" },
        { id: "ambiental", label: "ETE / ETA" },
        { id: "chorume", label: "Chorume" },
        { id: "fotovoltaica", label: "Fotovoltaica" },
        { id: "construcao-seca", label: "Construção Seca" },
      ],
      labels: { capacity: "Capacidade", location: "Localização", year: "Ano" },
      close: "Fechar detalhes do projeto",
      items: [
        {
          id: "ete-condominio",
          title: "ETE Compacta — Condomínio Parque das Águas",
          tagLabel: "ETE / ETA",
          location: "Rio de Janeiro · RJ",
          year: "2024",
          capacity: "240 m³/dia",
          scope: "Implantação completa de estação de tratamento de esgoto compacta, com sistema de aeração prolongada, decantação secundária e reuso de água para irrigação.",
        },
        {
          id: "chorume-aterro",
          title: "Tratamento de Chorume — Aterro Sanitário",
          tagLabel: "Chorume",
          location: "São Gonçalo · RJ",
          year: "2023",
          capacity: "60 m³/dia",
          scope: "Sistema de tratamento de percolado (chorume) com processo físico-químico e biológico, atendendo aos padrões de lançamento da CONAMA 430.",
        },
        {
          id: "usina-solar",
          title: "Usina Solar Fotovoltaica Industrial",
          tagLabel: "Fotovoltaica",
          location: "Duque de Caxias · RJ",
          year: "2024",
          capacity: "850 kWp",
          scope: "Projeto, homologação e montagem de usina solar de geração distribuída para autoprodução industrial, com payback estimado em 4 anos.",
        },
        {
          id: "steel-frame",
          title: "Edifício Comercial em Steel Frame",
          tagLabel: "Construção Seca",
          location: "Niterói · RJ",
          year: "2023",
          capacity: "4.200 m²",
          scope: "Construção seca completa com estrutura leve em steel frame, fechamento em placas cimentícias e alto desempenho termoacústico, com redução de 70% de resíduos.",
        },
        {
          id: "eta-modular",
          title: "ETA Modular Municipal",
          tagLabel: "ETE / ETA",
          location: "Itaboraí · RJ",
          year: "2025",
          capacity: "1.200 m³/dia",
          scope: "Estação de tratamento de água modular com floculação, decantação lamelar e desinfecção, ampliando o abastecimento de comunidades do entorno.",
        },
        {
          id: "retrofit-industrial",
          title: "Retrofit e Reforma de Planta Industrial",
          tagLabel: "Construção Seca",
          location: "Rio de Janeiro · RJ",
          year: "2024",
          capacity: "6.800 m²",
          scope: "Reforma de alta complexidade em planta industrial ativa, com reforço estrutural, modernização de instalações e gestão integrada de cronograma.",
        },
      ],
    },
    case: {
      eyebrow: "Case em Destaque",
      title: "Projeto Anel de Segurança pela Orla do Rio de Janeiro",
      objective: "O Projeto Anel de Segurança visa fortalecer a vigilância e a segurança ao longo da orla do Rio de Janeiro, implementando um sistema integrado de monitoramento inteligente para prevenir e conter crimes, especialmente o furto de cargas e outros delitos que impactam a região.",
      pmerjEyebrow: "Segurança pública",
      pmerjName: "Polícia Militar do Estado do Rio de Janeiro",
      pmerjAlt: "Brasão da Polícia Militar do Estado do Rio de Janeiro",
      techs: [
        {
          id: "speed-dome",
          title: "Speed Dome com IA e Reconhecimento Facial",
          desc: "Equipamentos de alta definição que permitem o monitoramento com identificação de pessoas com mandado de prisão pendente, alinhados à modernização da segurança pública.",
        },
        {
          id: "lpr",
          title: "Câmeras LPR de Placas Veiculares",
          desc: "Identificação de placas de veículos em alta definição, com leitura precisa mesmo em veículos a até 140 km/h.",
        },
        {
          id: "integracao",
          title: "Integração com PF e PRF",
          desc: "Integração com a Polícia Federal e a Polícia Rodoviária Federal para conter roubos de cargas e efetuar rápida identificação de veículos roubados.",
        },
      ],
      slides: [
        { caption: "Speed Dome com IA em ponto estratégico da orla", alt: "Câmera Speed Dome Hikvision instalada em poste na orla do Rio de Janeiro" },
        { caption: "Unidade de monitoramento com gabinete inteligente", alt: "Câmera de monitoramento e caixa de equipamentos em poste" },
        { caption: "Infraestrutura de campo do sistema integrado", alt: "Gabinete de equipamentos de vigilância instalado em poste" },
        { caption: "Câmera LPR para leitura de placas em alta velocidade", alt: "Câmera LPR de leitura de placas instalada em poste" },
      ],
      prev: "Imagem anterior",
      next: "Próxima imagem",
      goTo: "Ir para imagem",
    },
    contact: {
      eyebrow: "Contatos",
      title: "Vamos construir o seu próximo projeto?",
      lead: "Envie sua mensagem pelo formulário, por e-mail ou chame direto no WhatsApp. Nossa equipe comercial responde rápido.",
      emailLabel: "E-mail comercial",
      emailButton: "Enviar e-mail",
      whatsappLabel: "WhatsApp",
      whatsappButton: "Chamar no WhatsApp",
      formTitle: "Solicite um orçamento",
      name: "Nome *",
      namePlaceholder: "Seu nome",
      phone: "Telefone",
      phonePlaceholder: "(21) 99999-9999",
      email: "E-mail *",
      emailPlaceholder: "voce@empresa.com",
      service: "Serviço de interesse",
      message: "Mensagem *",
      messagePlaceholder: "Conte um pouco sobre o seu projeto...",
      submit: "Enviar mensagem",
      sending: "Enviando...",
      note: "Sua mensagem será enviada para",
      successTitle: "Mensagem enviada com sucesso!",
      successDesc: "Nossa equipe comercial retornará em breve.",
      errorTitle: "Não foi possível enviar sua mensagem.",
      errorDesc: "Tente pelo WhatsApp ou pelo e-mail direto.",
      serviceOptions: [
        "Construções",
        "Reformas",
        "Gestão de Projetos",
        "Engenharia Civil — Construções Secas",
        "Engenharia Ambiental — ETE / ETA",
        "Tratamento de Chorume",
        "Energia Solar Fotovoltaica",
        "Infraestrutura Elétrica",
        "Outro",
      ],
    },
    footer: {
      tagline: "Engenharia civil, ambiental e elétrica com foco em tratamento de água, chorume, construções secas e energia renovável.",
      navTitle: "Navegação",
      contactTitle: "Contato",
      rights: "Todos os direitos reservados.",
      disclaimer: "Projetos exibidos nesta página são ilustrativos da nossa área de atuação.",
    },
  },

  en: {
    seo: {
      title: "Water Treatment, WWTP/WTP & Environmental Engineering | Eco Build",
      description: "Environmental engineering in Rio de Janeiro, Brazil: WWTP/WTP deployment, water and leachate treatment, dry construction and photovoltaic solar energy. Request a quote.",
      ogLocale: "en_US",
    },
    wordmark: "engineering",
    nav: {
      home: "Home",
      sobre: "About",
      servicos: "Services",
      projetos: "Projects",
      case: "Case",
      contatos: "Contact",
      cta: "Quick Quote",
      menu: "Open menu",
      language: "Language",
    },
    hero: {
      badge: "Civil · Environmental · Electrical Engineering",
      lines: ["Engineering that", "treats water,", "builds the future."],
      sub: "Specialists in water and leachate treatment, WWTP/WTP deployment, dry construction and photovoltaic solar energy. Precision infrastructure for a sustainable future.",
      cta1: "Talk to Specialists",
      cta2: "Explore Solutions",
      pillars: ["WWTP & WTP", "Dry Construction", "Photovoltaic Energy"],
      imageAlt: "Water treatment plant",
    },
    marquee: [
      "Water Treatment · WWTP / WTP",
      "Leachate Treatment",
      "Dry Construction · Steel Frame",
      "Photovoltaic Solar Energy",
      "Project Management",
      "Electrical Infrastructure",
    ],
    about: {
      eyebrow: "About the Company",
      title: "More than buildings, we build a legacy.",
      p1: "EcoBuild is a leader in high-standard construction, integrating sustainable technology into every detail. Our commitment is to deliver projects that combine sophistication, efficiency and respect for the environment.",
      p2: "With innovative construction management, we guarantee excellence at every stage, from planning to final delivery. We believe sustainable construction is not just a trend, but a necessity for the future.",
      quote: "“At EcoBuild, we build more than buildings; we build a legacy of quality, innovation and environmental responsibility.”",
      imageAlt: "High-standard residence built by EcoBuild with sustainable technology",
      cardEyebrow: "Our commitment",
      cardText: "Sophistication, efficiency and respect for the environment.",
      values: [
        { id: "sustentabilidade", title: "Sustainability", desc: "Sustainable technology integrated into every project detail." },
        { id: "inovacao", title: "Innovation", desc: "Innovative construction management, from planning to final delivery." },
        { id: "excelencia", title: "Excellence", desc: "High standard of quality and sophistication at every stage." },
      ],
    },
    services: {
      eyebrow: "Our Services",
      title: "Integrated engineering solutions, from design to delivery.",
      lead: "We build, renovate and manage projects with the technical rigor engineering demands — and the environmental responsibility the future requires.",
      items: [
        {
          id: "construcoes",
          title: "Construction",
          alt: "Steel frame construction structure",
          desc: "Industrial, commercial and residential works executed with technical precision, controlled deadlines and high-performance materials.",
          bullets: ["Industrial and commercial works", "High-performance structures", "Rigorous quality control"],
        },
        {
          id: "reformas",
          title: "Renovations",
          alt: "Engineering team on a renovation site",
          desc: "Retrofit and highly complex renovations, planned to modernize your structure with minimal interference to your operation.",
          bullets: ["Structural and architectural retrofit", "Facilities modernization", "Minimal operational interference"],
        },
        {
          id: "gestao",
          title: "Project Management",
          alt: "Civil engineering project management",
          desc: "End-to-end management of engineering projects: planning, schedule, budget, site supervision and environmental compliance.",
          bullets: ["Planning and scheduling", "Technical site supervision", "Compliance and licensing"],
        },
      ],
    },
    disciplines: {
      eyebrow: "Areas of Expertise",
      title: "Three engineering fields. One single standard of excellence.",
      items: [
        {
          id: "civil",
          code: "01",
          eyebrow: "Civil Engineering",
          title: "Dry construction: speed, precision and almost zero waste.",
          alt: "Dry construction steel structure",
          desc: "We lead the transition to industrialized construction systems. With steel frame, drywall and panel enclosures, we deliver faster, cleaner and more efficient buildings than conventional masonry.",
          bullets: [
            "Steel Frame and Drywall systems",
            "Fast assembly with high thermal and acoustic efficiency",
            "Sustainable works with up to 70% waste reduction",
            "Millimetric precision of industrialized design",
          ],
          chips: ["Steel Frame", "Drywall", "Low Waste"],
        },
        {
          id: "ambiental",
          code: "02",
          eyebrow: "Environmental Engineering",
          title: "Water and leachate treatment with cutting-edge technology.",
          alt: "Water treatment plant",
          desc: "We design and deploy wastewater treatment plants (WWTP) and water treatment plants (WTP), as well as complete leachate treatment systems for landfills and industries — always in compliance with environmental legislation.",
          bullets: [
            "WWTP deployment — Wastewater Treatment Plants",
            "WTP deployment — Water Treatment Plants",
            "Leachate treatment in landfills and industries",
            "Project management and environmental licensing",
          ],
          chips: ["WWTP", "WTP", "Leachate", "Licensing"],
        },
        {
          id: "eletrica",
          code: "03",
          eyebrow: "Electrical Engineering",
          title: "Renewable energy and infrastructure to operate without interruptions.",
          alt: "Photovoltaic solar panels",
          desc: "From design to utility approval, we implement photovoltaic solar energy systems and robust electrical infrastructures that reduce operating costs and your business's carbon footprint.",
          bullets: [
            "Photovoltaic solar energy systems",
            "High and medium voltage electrical infrastructure",
            "Industrial energy efficiency",
            "Utility company approval process",
          ],
          chips: ["Photovoltaic", "High Voltage", "Efficiency"],
        },
      ],
    },
    projects: {
      eyebrow: "Portfolio",
      title: "Projects that turn resources into results.",
      lead: "An illustrative selection of our work in treatment plants, renewable energy and high-performance construction.",
      filters: [
        { id: "todos", label: "All" },
        { id: "ambiental", label: "WWTP / WTP" },
        { id: "chorume", label: "Leachate" },
        { id: "fotovoltaica", label: "Photovoltaic" },
        { id: "construcao-seca", label: "Dry Construction" },
      ],
      labels: { capacity: "Capacity", location: "Location", year: "Year" },
      close: "Close project details",
      items: [
        {
          id: "ete-condominio",
          title: "Compact WWTP — Parque das Águas Condominium",
          tagLabel: "WWTP / WTP",
          location: "Rio de Janeiro · RJ",
          year: "2024",
          capacity: "240 m³/day",
          scope: "Complete deployment of a compact wastewater treatment plant, with extended aeration system, secondary settling and water reuse for irrigation.",
        },
        {
          id: "chorume-aterro",
          title: "Leachate Treatment — Sanitary Landfill",
          tagLabel: "Leachate",
          location: "São Gonçalo · RJ",
          year: "2023",
          capacity: "60 m³/day",
          scope: "Leachate (percolate) treatment system with physicochemical and biological processes, meeting CONAMA 430 discharge standards.",
        },
        {
          id: "usina-solar",
          title: "Industrial Photovoltaic Solar Plant",
          tagLabel: "Photovoltaic",
          location: "Duque de Caxias · RJ",
          year: "2024",
          capacity: "850 kWp",
          scope: "Design, approval and assembly of a distributed generation solar plant for industrial self-production, with an estimated 4-year payback.",
        },
        {
          id: "steel-frame",
          title: "Steel Frame Commercial Building",
          tagLabel: "Dry Construction",
          location: "Niterói · RJ",
          year: "2023",
          capacity: "4,200 m²",
          scope: "Complete dry construction with light steel frame structure, cementitious panel enclosures and high thermoacoustic performance, with 70% waste reduction.",
        },
        {
          id: "eta-modular",
          title: "Modular Municipal WTP",
          tagLabel: "WWTP / WTP",
          location: "Itaboraí · RJ",
          year: "2025",
          capacity: "1,200 m³/day",
          scope: "Modular water treatment plant with flocculation, lamellar settling and disinfection, expanding the water supply of surrounding communities.",
        },
        {
          id: "retrofit-industrial",
          title: "Industrial Plant Retrofit and Renovation",
          tagLabel: "Dry Construction",
          location: "Rio de Janeiro · RJ",
          year: "2024",
          capacity: "6,800 m²",
          scope: "Highly complex renovation in an active industrial plant, with structural reinforcement, facilities modernization and integrated schedule management.",
        },
      ],
    },
    case: {
      eyebrow: "Featured Case",
      title: "Security Ring Project along the Rio de Janeiro Coastline",
      objective: "The Security Ring Project aims to strengthen surveillance and safety along the Rio de Janeiro coastline, implementing an integrated intelligent monitoring system to prevent and curb crimes, especially cargo theft and other offenses that impact the region.",
      pmerjEyebrow: "Public security",
      pmerjName: "Military Police of the State of Rio de Janeiro",
      pmerjAlt: "Coat of arms of the Military Police of the State of Rio de Janeiro",
      techs: [
        {
          id: "speed-dome",
          title: "Speed Dome with AI and Facial Recognition",
          desc: "High-definition equipment that enables monitoring with identification of people with pending arrest warrants, aligned with the modernization of public security.",
        },
        {
          id: "lpr",
          title: "LPR License Plate Cameras",
          desc: "High-definition vehicle plate identification, with accurate reading even on vehicles at up to 140 km/h.",
        },
        {
          id: "integracao",
          title: "Integration with Federal Agencies",
          desc: "Integration with the Federal Police and the Federal Highway Police to curb cargo theft and quickly identify stolen vehicles.",
        },
      ],
      slides: [
        { caption: "AI Speed Dome at a strategic coastline point", alt: "Hikvision Speed Dome camera installed on a pole on the Rio de Janeiro coastline" },
        { caption: "Monitoring unit with smart cabinet", alt: "Monitoring camera and equipment box on a pole" },
        { caption: "Field infrastructure of the integrated system", alt: "Surveillance equipment cabinet installed on a pole" },
        { caption: "LPR camera for high-speed plate reading", alt: "LPR plate-reading camera installed on a pole" },
      ],
      prev: "Previous image",
      next: "Next image",
      goTo: "Go to image",
    },
    contact: {
      eyebrow: "Contact",
      title: "Shall we build your next project together?",
      lead: "Send your message through the form, by email or reach us directly on WhatsApp. Our commercial team responds quickly.",
      emailLabel: "Commercial email",
      emailButton: "Send email",
      whatsappLabel: "WhatsApp",
      whatsappButton: "Chat on WhatsApp",
      formTitle: "Request a quote",
      name: "Name *",
      namePlaceholder: "Your name",
      phone: "Phone",
      phonePlaceholder: "+55 (21) 99999-9999",
      email: "Email *",
      emailPlaceholder: "you@company.com",
      service: "Service of interest",
      message: "Message *",
      messagePlaceholder: "Tell us a little about your project...",
      submit: "Send message",
      sending: "Sending...",
      note: "Your message will be sent to",
      successTitle: "Message sent successfully!",
      successDesc: "Our commercial team will get back to you soon.",
      errorTitle: "We could not send your message.",
      errorDesc: "Please try via WhatsApp or direct email.",
      serviceOptions: [
        "Construction",
        "Renovations",
        "Project Management",
        "Civil Engineering — Dry Construction",
        "Environmental Engineering — WWTP / WTP",
        "Leachate Treatment",
        "Photovoltaic Solar Energy",
        "Electrical Infrastructure",
        "Other",
      ],
    },
    footer: {
      tagline: "Civil, environmental and electrical engineering focused on water treatment, leachate, dry construction and renewable energy.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      rights: "All rights reserved.",
      disclaimer: "Projects shown on this page are illustrative of our areas of work.",
    },
  },

  es: {
    seo: {
      title: "Tratamiento de Agua, EDE/EDA e Ingeniería Ambiental | Eco Build",
      description: "Ingeniería ambiental en Río de Janeiro, Brasil: implantación de EDE/EDA, tratamiento de agua y lixiviados, construcciones secas y energía solar fotovoltaica. Pida su cotización.",
      ogLocale: "es_ES",
    },
    wordmark: "ingeniería",
    nav: {
      home: "Inicio",
      sobre: "Nosotros",
      servicos: "Servicios",
      projetos: "Proyectos",
      case: "Caso",
      contatos: "Contacto",
      cta: "Cotización Rápida",
      menu: "Abrir menú",
      language: "Idioma",
    },
    hero: {
      badge: "Ingeniería Civil · Ambiental · Eléctrica",
      lines: ["Ingeniería que", "trata el agua,", "construye el futuro."],
      sub: "Especialistas en tratamiento de agua y lixiviados, implantación de EDE/EDA, construcciones secas y energía solar fotovoltaica. Infraestructura de precisión para un futuro sostenible.",
      cta1: "Hablar con Especialistas",
      cta2: "Explorar Soluciones",
      pillars: ["EDE & EDA", "Construcciones Secas", "Energía Fotovoltaica"],
      imageAlt: "Estación de tratamiento de agua",
    },
    marquee: [
      "Tratamiento de Agua · EDE / EDA",
      "Tratamiento de Lixiviados",
      "Construcciones Secas · Steel Frame",
      "Energía Solar Fotovoltaica",
      "Gestión de Proyectos",
      "Infraestructura Eléctrica",
    ],
    about: {
      eyebrow: "Sobre la Empresa",
      title: "Más que edificios, construimos un legado.",
      p1: "EcoBuild es líder en construcciones de alto estándar, integrando tecnología sostenible en cada detalle. Nuestro compromiso es entregar proyectos que combinan sofisticación, eficiencia y respeto al medio ambiente.",
      p2: "Con una gestión de obras innovadora, garantizamos excelencia en cada etapa, desde la planificación hasta la entrega final. Creemos que la construcción sostenible no es solo una tendencia, sino una necesidad para el futuro.",
      quote: "“En EcoBuild, construimos más que edificios; construimos un legado de calidad, innovación y responsabilidad ambiental.”",
      imageAlt: "Residencia de alto estándar construida por EcoBuild con tecnología sostenible",
      cardEyebrow: "Nuestro compromiso",
      cardText: "Sofisticación, eficiencia y respeto al medio ambiente.",
      values: [
        { id: "sustentabilidade", title: "Sostenibilidad", desc: "Tecnología sostenible integrada en cada detalle del proyecto." },
        { id: "inovacao", title: "Innovación", desc: "Gestión de obras innovadora, de la planificación a la entrega final." },
        { id: "excelencia", title: "Excelencia", desc: "Alto estándar de calidad y sofisticación en cada etapa ejecutada." },
      ],
    },
    services: {
      eyebrow: "Nuestros Servicios",
      title: "Soluciones integradas de ingeniería, del proyecto a la entrega.",
      lead: "Construimos, reformamos y gestionamos proyectos con el rigor técnico que la ingeniería exige — y con la responsabilidad ambiental que el futuro demanda.",
      items: [
        {
          id: "construcoes",
          title: "Construcciones",
          alt: "Estructura de construcción en steel frame",
          desc: "Obras industriales, comerciales y residenciales ejecutadas con precisión técnica, plazos controlados y materiales de alto rendimiento.",
          bullets: ["Obras industriales y comerciales", "Estructuras de alto rendimiento", "Control riguroso de calidad"],
        },
        {
          id: "reformas",
          title: "Reformas",
          alt: "Equipo de ingeniería en obra de reforma",
          desc: "Retrofit y reformas de alta complejidad, planificadas para modernizar su estructura con mínima interferencia en la operación.",
          bullets: ["Retrofit estructural y arquitectónico", "Modernización de instalaciones", "Mínima interferencia operativa"],
        },
        {
          id: "gestao",
          title: "Gestión de Proyectos",
          alt: "Gestión de proyecto de ingeniería civil",
          desc: "Gestión integral de proyectos de ingeniería: planificación, cronograma, presupuesto, supervisión y cumplimiento ambiental.",
          bullets: ["Planificación y cronograma", "Supervisión técnica de obras", "Cumplimiento y licencias"],
        },
      ],
    },
    disciplines: {
      eyebrow: "Áreas de Actuación",
      title: "Tres ingenierías. Un único estándar de excelencia.",
      items: [
        {
          id: "civil",
          code: "01",
          eyebrow: "Ingeniería Civil",
          title: "Construcciones secas: velocidad, precisión y casi cero residuos.",
          alt: "Estructura metálica de construcción seca",
          desc: "Lideramos la transición hacia sistemas constructivos industrializados. Con steel frame, drywall y cerramientos en placas, entregamos obras más rápidas, limpias y eficientes que la albañilería convencional.",
          bullets: [
            "Sistemas Steel Frame y Drywall",
            "Montaje rápido con alta eficiencia térmica y acústica",
            "Obras sostenibles con reducción de hasta 70% de residuos",
            "Precisión milimétrica de proyecto industrializado",
          ],
          chips: ["Steel Frame", "Drywall", "Bajos Residuos"],
        },
        {
          id: "ambiental",
          code: "02",
          eyebrow: "Ingeniería Ambiental",
          title: "Tratamiento de agua y lixiviados con tecnología de punta.",
          alt: "Estación de tratamiento de agua",
          desc: "Diseñamos e implantamos estaciones de tratamiento de aguas residuales (EDE) y de agua potable (EDA), además de sistemas completos para tratamiento de lixiviados en vertederos e industrias — siempre en conformidad con la legislación ambiental.",
          bullets: [
            "Implantación de EDE — Estación de Depuración de Aguas Residuales",
            "Implantación de EDA — Estación de Tratamiento de Agua",
            "Tratamiento de lixiviados en vertederos e industrias",
            "Gestión de proyectos y licenciamiento ambiental",
          ],
          chips: ["EDE", "EDA", "Lixiviados", "Licencias"],
        },
        {
          id: "eletrica",
          code: "03",
          eyebrow: "Ingeniería Eléctrica",
          title: "Energía renovable e infraestructura para operar sin interrupciones.",
          alt: "Paneles solares fotovoltaicos",
          desc: "Del proyecto a la homologación, implementamos sistemas de energía solar fotovoltaica e infraestructuras eléctricas robustas que reducen costos operativos y la huella de carbono de su negocio.",
          bullets: [
            "Sistemas de energía solar fotovoltaica",
            "Infraestructura eléctrica de alta y media tensión",
            "Eficiencia energética industrial",
            "Homologación ante la distribuidora",
          ],
          chips: ["Fotovoltaica", "Alta Tensión", "Eficiencia"],
        },
      ],
    },
    projects: {
      eyebrow: "Portafolio",
      title: "Proyectos que transforman recursos en resultados.",
      lead: "Una selección ilustrativa de nuestra actuación en estaciones de tratamiento, energía renovable y construcciones de alto rendimiento.",
      filters: [
        { id: "todos", label: "Todos" },
        { id: "ambiental", label: "EDE / EDA" },
        { id: "chorume", label: "Lixiviados" },
        { id: "fotovoltaica", label: "Fotovoltaica" },
        { id: "construcao-seca", label: "Construcción Seca" },
      ],
      labels: { capacity: "Capacidad", location: "Ubicación", year: "Año" },
      close: "Cerrar detalles del proyecto",
      items: [
        {
          id: "ete-condominio",
          title: "EDE Compacta — Condominio Parque das Águas",
          tagLabel: "EDE / EDA",
          location: "Río de Janeiro · RJ",
          year: "2024",
          capacity: "240 m³/día",
          scope: "Implantación completa de estación de tratamiento de aguas residuales compacta, con sistema de aireación prolongada, decantación secundaria y reúso de agua para riego.",
        },
        {
          id: "chorume-aterro",
          title: "Tratamiento de Lixiviados — Vertedero Sanitario",
          tagLabel: "Lixiviados",
          location: "São Gonçalo · RJ",
          year: "2023",
          capacity: "60 m³/día",
          scope: "Sistema de tratamiento de percolado (lixiviado) con proceso fisicoquímico y biológico, cumpliendo los estándares de vertido de la CONAMA 430.",
        },
        {
          id: "usina-solar",
          title: "Planta Solar Fotovoltaica Industrial",
          tagLabel: "Fotovoltaica",
          location: "Duque de Caxias · RJ",
          year: "2024",
          capacity: "850 kWp",
          scope: "Proyecto, homologación y montaje de planta solar de generación distribuida para autoproducción industrial, con retorno estimado en 4 años.",
        },
        {
          id: "steel-frame",
          title: "Edificio Comercial en Steel Frame",
          tagLabel: "Construcción Seca",
          location: "Niterói · RJ",
          year: "2023",
          capacity: "4.200 m²",
          scope: "Construcción seca completa con estructura ligera en steel frame, cerramiento en placas cementicias y alto desempeño termoacústico, con reducción del 70% de residuos.",
        },
        {
          id: "eta-modular",
          title: "EDA Modular Municipal",
          tagLabel: "EDE / EDA",
          location: "Itaboraí · RJ",
          year: "2025",
          capacity: "1.200 m³/día",
          scope: "Estación de tratamiento de agua modular con floculación, decantación lamelar y desinfección, ampliando el abastecimiento de comunidades del entorno.",
        },
        {
          id: "retrofit-industrial",
          title: "Retrofit y Reforma de Planta Industrial",
          tagLabel: "Construcción Seca",
          location: "Río de Janeiro · RJ",
          year: "2024",
          capacity: "6.800 m²",
          scope: "Reforma de alta complejidad en planta industrial activa, con refuerzo estructural, modernización de instalaciones y gestión integrada de cronograma.",
        },
      ],
    },
    case: {
      eyebrow: "Caso Destacado",
      title: "Proyecto Anillo de Seguridad por la Costanera de Río de Janeiro",
      objective: "El Proyecto Anillo de Seguridad busca fortalecer la vigilancia y la seguridad a lo largo de la costanera de Río de Janeiro, implementando un sistema integrado de monitoreo inteligente para prevenir y contener delitos, especialmente el robo de cargas y otros delitos que impactan la región.",
      pmerjEyebrow: "Seguridad pública",
      pmerjName: "Policía Militar del Estado de Río de Janeiro",
      pmerjAlt: "Escudo de la Policía Militar del Estado de Río de Janeiro",
      techs: [
        {
          id: "speed-dome",
          title: "Speed Dome con IA y Reconocimiento Facial",
          desc: "Equipos de alta definición que permiten el monitoreo con identificación de personas con orden de prisión pendiente, alineados a la modernización de la seguridad pública.",
        },
        {
          id: "lpr",
          title: "Cámaras LPR de Placas Vehiculares",
          desc: "Identificación de placas de vehículos en alta definición, con lectura precisa incluso en vehículos a hasta 140 km/h.",
        },
        {
          id: "integracao",
          title: "Integración con PF y PRF",
          desc: "Integración con la Policía Federal y la Policía Rodoviaria Federal para contener robos de cargas y efectuar rápida identificación de vehículos robados.",
        },
      ],
      slides: [
        { caption: "Speed Dome con IA en punto estratégico de la costanera", alt: "Cámara Speed Dome Hikvision instalada en poste en la costanera de Río de Janeiro" },
        { caption: "Unidad de monitoreo con gabinete inteligente", alt: "Cámara de monitoreo y caja de equipos en poste" },
        { caption: "Infraestructura de campo del sistema integrado", alt: "Gabinete de equipos de vigilancia instalado en poste" },
        { caption: "Cámara LPR para lectura de placas en alta velocidad", alt: "Cámara LPR de lectura de placas instalada en poste" },
      ],
      prev: "Imagen anterior",
      next: "Próxima imagen",
      goTo: "Ir a la imagen",
    },
    contact: {
      eyebrow: "Contacto",
      title: "¿Construimos su próximo proyecto juntos?",
      lead: "Envíe su mensaje por el formulario, por e-mail o llame directo por WhatsApp. Nuestro equipo comercial responde rápido.",
      emailLabel: "E-mail comercial",
      emailButton: "Enviar e-mail",
      whatsappLabel: "WhatsApp",
      whatsappButton: "Llamar por WhatsApp",
      formTitle: "Solicite una cotización",
      name: "Nombre *",
      namePlaceholder: "Su nombre",
      phone: "Teléfono",
      phonePlaceholder: "+55 (21) 99999-9999",
      email: "E-mail *",
      emailPlaceholder: "usted@empresa.com",
      service: "Servicio de interés",
      message: "Mensaje *",
      messagePlaceholder: "Cuéntenos un poco sobre su proyecto...",
      submit: "Enviar mensaje",
      sending: "Enviando...",
      note: "Su mensaje será enviado a",
      successTitle: "¡Mensaje enviado con éxito!",
      successDesc: "Nuestro equipo comercial responderá pronto.",
      errorTitle: "No fue posible enviar su mensaje.",
      errorDesc: "Intente por WhatsApp o por e-mail directo.",
      serviceOptions: [
        "Construcciones",
        "Reformas",
        "Gestión de Proyectos",
        "Ingeniería Civil — Construcciones Secas",
        "Ingeniería Ambiental — EDE / EDA",
        "Tratamiento de Lixiviados",
        "Energía Solar Fotovoltaica",
        "Infraestructura Eléctrica",
        "Otro",
      ],
    },
    footer: {
      tagline: "Ingeniería civil, ambiental y eléctrica con foco en tratamiento de agua, lixiviados, construcciones secas y energía renovable.",
      navTitle: "Navegación",
      contactTitle: "Contacto",
      rights: "Todos los derechos reservados.",
      disclaimer: "Los proyectos exhibidos en esta página son ilustrativos de nuestra área de actuación.",
    },
  },
};
